export const accountInfoSliderOptions = {
  simulateTouch: false,
  // autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: '[data-account-type-slider]',
    autoScrollOffset: 0.5,
  },
};

export const assetInfoSliderOptions = {
  simulateTouch: false,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: '[data-asset-type-slider]',
    autoScrollOffset: 0.5,
  },
};

export const thumbsSliderOptions = {
  threshold: 1,
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  spaceBetween: 12,
  breakpoints: {
    601: {
      spaceBetween: 16,
    },
  },
};

export const tabsSliderOptions = {
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  spaceBetween: 16,
};

export const tabsContentSliderOptions = {
  slidesPerView: 1,
  simulateTouch: false,
  autoHeight: true,

  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },

  thumbs: {
    swiper: '[data-accounts-tabs-slider]',
    autoScrollOffset: 0.5,
  },
};
